export default function excelExportCallback(params) {
  const value = params.value
  if (typeof value === "string" && value.includes("<a href")) {
    const displayValue = $(value).text()
    const urlPath = $(value).attr("href")
    return `=HYPERLINK("${window.location.protocol}//${window.location.host}${urlPath}", "${displayValue}")`
  } else {
    return value
  }
}
